import { logger as N } from "../../shared-lib/index.js";
export function setLogger(e) {
  N.setLogger(e);
}
